var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.crop.stage,style:(_vm.plantPosition)},[_c('div',{staticClass:"plant-spot premium",class:[
            _vm.selected ? 'selected' : '',
            _vm.focused ? 'plant-spot-active' : '',
            _vm.over && !_vm.locked ? 'hover' : '',
            _vm.empty ? '' : 'planted',
        ],style:(_vm.plantStyle)}),(_vm.crop.cropId && _vm.showPlantTooltip)?_c('div',{staticClass:"plant-spot-tooltip"},[_c('GrowthDisplay',{attrs:{"boost-modifier":_vm.crop.boostModifier || 0,"stage":_vm.crop.stage}})],1):_vm._e(),_c('div',{staticClass:"bounding-box",on:{"click":_vm.handleClick,"mouseover":_vm.setHover,"mouseleave":_vm.unsetHover}})])
}
var staticRenderFns = []

export { render, staticRenderFns }